import * as React from 'react';

import type {FormType} from 'nutshell-graphql-types';

import {useFormUpdate} from '../../helpers';

import {AfterSubmissionCard} from './after-submission-card';
import {AfterSubmissionForm} from './after-submission-form';
import {AfterSubmissionSidebarForm} from './after-submission-sidebar-form';

import styles from './after-submission-container.module.css';

type Props = {
    formId: string;
    formType?: FormType;
    afterSubmissionText: string | null | undefined;
    redirectUrl: string | null | undefined;
};

export function AfterSubmissionContainer(props: Props) {
    const [showingAfterSubmissionSidebar, setShowingAfterSubmissionSidebar] =
        React.useState<boolean>(false);

    const [saveFailedErrorMessage, setSaveFailedErrorMessage] = React.useState<
        string | null | undefined
    >(null);

    const updateForm = useFormUpdate();
    // @ts-expect-error
    const saveAfterSubmission = (formData): Promise<any> | null | undefined => {
        if (props.formType && props.formType === 'CHAT' && formData.actionType === 'redirectUrl') {
            setSaveFailedErrorMessage('Chat forms do not support redirecting to a URL');
        } else {
            const saveData = {
                id: props.formId,
                afterSubmissionText:
                    (formData.actionType === 'message' && formData.message) ||
                    (formData.actionType === 'redirectUrl' && !formData.redirectUrl.length)
                        ? formData.message
                        : null,
                redirectUrl:
                    formData.actionType === 'redirectUrl' && formData.redirectUrl
                        ? formData.redirectUrl
                        : null,
            } as const;

            return updateForm({
                form: saveData,
            })
                .then(() => {
                    setSaveFailedErrorMessage(null);
                    setShowingAfterSubmissionSidebar(false);
                })
                .catch((error) => {
                    setSaveFailedErrorMessage(error.message);
                });
        }
    };

    return (
        <div className={styles['after-submission-container']}>
            <AfterSubmissionCard
                type={props.redirectUrl ? 'redirectUrl' : 'message'}
                content={props.redirectUrl ? props.redirectUrl : props.afterSubmissionText}
                onClick={() => {
                    setShowingAfterSubmissionSidebar(true);
                }}
            />
            {showingAfterSubmissionSidebar ? (
                <AfterSubmissionSidebarForm
                    // @ts-expect-error
                    title='After submission'
                    onClose={() => {
                        setShowingAfterSubmissionSidebar(false);
                        setSaveFailedErrorMessage(null);
                    }}
                    // @ts-expect-error
                    onSubmit={(formData) => {
                        return saveAfterSubmission(formData);
                    }}
                    saveFailedErrorMessage={saveFailedErrorMessage}
                    initialValues={{
                        actionType: props.afterSubmissionText ? 'message' : 'redirectUrl',
                        redirectUrl: props.redirectUrl,
                        message: props.afterSubmissionText,
                    }}
                >
                    <AfterSubmissionForm
                        disableRedirectUrl={props.formType && props.formType === 'CHAT'}
                    />
                </AfterSubmissionSidebarForm>
            ) : undefined}
        </div>
    );
}
